<ng-template #trainBradcrumbs let-train="train" let-last="last">
  @if (train.type == 'multi' && train.subSegments) {
    @for (t of train.subSegments; track t; let last = $last) {
      <ng-container
        [ngTemplateOutlet]='trainBradcrumbs'
        [ngTemplateOutletContext]='{last:last, train:t}'
      ></ng-container>
    }
  }
  @if (train.type != 'multi') {
    @if (trainTypeImages[train.value]) {
      <img  [src]="trainTypeImages[train.value]" class="train-icon"/>
    }
    <small class="train-name"> {{train.name}}</small>
  }
  @if (!last) {
    <span> / </span>
  }
</ng-template>

<div>
  <span>
    {{solutionData.start.stationName}}
    <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    {{solutionData.end.stationName}}
  </span>
</div>
@for (solution of solutions ; track solution) {
  <mat-card (click)="auth(solution.offers)">
    <div class="fx-row fx-justify-space-between fx-items-center">
      <div class="fx-flex">
        <div class="train-breacrumbs">
          @for (t of solution.trains; track t; let last = $last) {
            <ng-container
              [ngTemplateOutlet]='trainBradcrumbs'
              [ngTemplateOutletContext]='{last:last, train:t}'
            ></ng-container>
          }
        </div>
        <div class="fx-row" style="gap: 12px">
          <div class="solution" style="flex: 1 1 40%; max-width: 40%">{{solution.title | lowercase}}</div>
          <div class="fx-flex-30">
            @for (level of solution.levels; track level; let last = $last) {
              <span>
                <span class="level">{{level.value}}</span>
                @if (!last) {
                  <span class="level"> / </span>
                }
              </span>
            }
          </div>
        </div>
      </div>
      <div class="fx-flex" style="text-align: right">
        <span class="tr-price"
          matTooltip="{{solution.fee>0?'Prezzo:€ '+solution.netPrice+' + Diritti agenzia:€ '+solution.fee:''}}"
        >{{solution.price | currency:'EUR':'symbol':'1.2-2'}}</span>
        <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
      </div>
    </div>
  </mat-card>
}
